export default __webpack_public_path__ + "static/media/ic_hawaii.2d6afbfe.svg";